var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 55px)" } },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "scroll pageborder",
            staticStyle: {
              height: "calc(100vh - 75px)",
              float: "left",
              "margin-right": "0px",
              width: "48%"
            },
            attrs: { id: "left" }
          },
          [
            _c(
              "div",
              { staticStyle: { height: "50px", padding: "0px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "pageborder",
                    staticStyle: {
                      float: "left",
                      width: "150px",
                      height: "45px"
                    }
                  },
                  [_c("p", [_vm._v("WO#: 11-" + _vm._s(_vm.woData[0]))])]
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  {
                    key: _vm.updateKey,
                    staticStyle: {
                      float: "left",
                      "margin-left": "10px",
                      width: "150px",
                      height: "45px"
                    },
                    attrs: { text: _vm.reportFormats[_vm.format][2] }
                  },
                  _vm._l(_vm.reportFormats, function(format, i) {
                    return _c(
                      "b-dropdown-item",
                      {
                        on: {
                          click: function($event) {
                            return _vm.setFormat(i)
                          }
                        }
                      },
                      [_vm._v(_vm._s(format[2]))]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "500px",
                  height: "45px",
                  "margin-top": "10px"
                }
              },
              [
                _c("b", { staticStyle: { "font-size": "24px" } }, [
                  _vm._v(_vm._s(_vm.reportFormats[_vm.format][2]))
                ])
              ]
            ),
            _vm._v(" "),
            _vm.times.length > 0
              ? _c("table", { key: _vm.updatekey, staticClass: "block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [_vm._v("Vessel")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "woData" }, [
                          _vm._v(_vm._s(_vm.woData[1]))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "woBlock", attrs: { rowspan: "2" } },
                        [
                          _c("p", { staticClass: "woTitle" }, [
                            _vm._v(_vm._s(_vm.times[1][2]))
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "woCheckboxLabel upper",
                              attrs: { for: "checkBoxA" }
                            },
                            [_vm._v("Starboard")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sideS,
                                expression: "sideS"
                              }
                            ],
                            staticClass: "woCheckbox upper",
                            attrs: {
                              tabindex: "2",
                              type: "checkbox",
                              name: "checkBoxA"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.sideS)
                                ? _vm._i(_vm.sideS, null) > -1
                                : _vm.sideS
                            },
                            on: {
                              input: function($event) {
                                return _vm.sideChanged("Starboard")
                              },
                              change: function($event) {
                                var $$a = _vm.sideS,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.sideS = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.sideS = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.sideS = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "woCheckboxLabel lower",
                              attrs: { for: "checkBoxB" }
                            },
                            [_vm._v("Port")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sideP,
                                expression: "sideP"
                              }
                            ],
                            staticClass: "woCheckbox lower",
                            attrs: {
                              tabindex: "3",
                              type: "checkbox",
                              name: "checkBoxB"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.sideP)
                                ? _vm._i(_vm.sideP, null) > -1
                                : _vm.sideP
                            },
                            on: {
                              input: function($event) {
                                return _vm.sideChanged("Port")
                              },
                              change: function($event) {
                                var $$a = _vm.sideP,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.sideP = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.sideP = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.sideP = $$c
                                }
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [_vm._v("Port")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "woData" }, [
                          _vm._v(_vm._s(_vm.woData[2]))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [_vm._v("Pier")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "woData" }, [
                          _vm._v(_vm._s(_vm.woData[3]))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c(
                          "p",
                          {
                            staticClass: "woTitle",
                            attrs: { title: "YYYY-MM-DD" }
                          },
                          [_vm._v("Date")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.woData[4],
                              expression: "woData[4]"
                            }
                          ],
                          staticClass: "woInput",
                          attrs: { tabindex: "6", title: "YYYY-MM-DD" },
                          domProps: { value: _vm.woData[4] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.woData, 4, $event.target.value)
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [
                          _vm._v(_vm._s(_vm.times[0][2]))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.times[0][5],
                              expression: "times[0][5]"
                            }
                          ],
                          staticClass: "woInput",
                          attrs: { tabindex: "1" },
                          domProps: { value: _vm.times[0][5] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.times[0], 5, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [
                          _vm._v(_vm._s(_vm.times[2][2]))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.times[2][5],
                              expression: "times[2][5]"
                            }
                          ],
                          staticClass: "woInput",
                          attrs: { tabindex: "4" },
                          domProps: { value: _vm.times[2][5] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.times[2], 5, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [
                          _vm._v(_vm._s(_vm.times[3][2]))
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.times[3][5],
                              expression: "times[3][5]"
                            }
                          ],
                          staticClass: "woInput",
                          attrs: { tabindex: "5" },
                          domProps: { value: _vm.times[3][5] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.times[3], 5, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "woBlock" }, [
                        _c("p", { staticClass: "woTitle" }, [
                          _vm._v("Customer")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "woData" }, [
                          _vm._v(_vm._s(_vm.woData[7]))
                        ])
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.times.length > 0
              ? _c("table", { key: _vm.updatekey, staticClass: "block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        { key: _vm.updatekey, staticClass: "meterBox" },
                        [
                          _c("p", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.times[4][2]))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.times[4][5],
                                expression: "times[4][5]"
                              }
                            ],
                            attrs: { tabindex: "7" },
                            domProps: { value: _vm.times[4][5] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.times[4], 5, $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.times[4][6]))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { key: _vm.updatekey, staticClass: "meterBox" },
                        [
                          _c("p", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.times[5][2]))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.times[5][5],
                                expression: "times[5][5]"
                              }
                            ],
                            attrs: { tabindex: "8" },
                            domProps: { value: _vm.times[5][5] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.times[5], 5, $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.times[5][6]))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { key: _vm.updatekey, staticClass: "meterBox" },
                        [
                          _c("p", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.times[6][2]))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.times[6][5],
                                expression: "times[6][5]"
                              }
                            ],
                            attrs: { tabindex: "9" },
                            domProps: { value: _vm.times[6][5] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.times[6], 5, $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.times[6][6]))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { key: _vm.updatekey, staticClass: "meterBox" },
                        [
                          _c("p", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.times[7][2]))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.times[7][5],
                                expression: "times[7][5]"
                              }
                            ],
                            attrs: { tabindex: "10" },
                            domProps: { value: _vm.times[7][5] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.times[7], 5, $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.times[7][6]))])
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function(j) {
                  return _c(
                    "tr",
                    _vm._l(3, function(i) {
                      return _vm.times.length > _vm.getIndex(i, j)
                        ? _c(
                            "td",
                            { key: _vm.updatekey, staticClass: "timeBox" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.times[_vm.getIndex(i, j)][2]))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.times[_vm.getIndex(i, j)][3],
                                    expression: "times[getIndex(i,j)][3]"
                                  }
                                ],
                                staticStyle: {
                                  height: "20px",
                                  top: "5px",
                                  "font-size": "10px"
                                },
                                attrs: {
                                  tabindex: "-1",
                                  onClick: "this.select();"
                                },
                                domProps: {
                                  value: _vm.times[_vm.getIndex(i, j)][3]
                                },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.times[_vm.getIndex(i, j)],
                                        3,
                                        $event.target.value
                                      )
                                    },
                                    function($event) {}
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.times[_vm.getIndex(i, j)][4],
                                    expression: "times[getIndex(i,j)][4]"
                                  }
                                ],
                                staticStyle: { height: "30px", bottom: "5px" },
                                attrs: {
                                  tabindex: _vm.getIndex(i, j) + 2,
                                  onClick: "this.select();"
                                },
                                domProps: {
                                  value: _vm.times[_vm.getIndex(i, j)][4]
                                },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.times[_vm.getIndex(i, j)],
                                        4,
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      _vm.timeChanged(_vm.getIndex(i, j))
                                    }
                                  ]
                                }
                              })
                            ]
                          )
                        : _c("td", { staticClass: "timeBox" }, [
                            _c("p", [_vm._v("_________")]),
                            _vm._v(" "),
                            _c("input", {
                              staticStyle: {
                                height: "20px",
                                top: "5px",
                                "font-size": "10px"
                              },
                              attrs: {
                                tabindex: "-1",
                                onClick: "this.select();"
                              },
                              on: { input: function($event) {} }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              staticStyle: { height: "30px", bottom: "5px" },
                              attrs: {
                                tabindex: _vm.getIndex(i, j) + 2,
                                onClick: "this.select();"
                              },
                              on: { input: function($event) {} }
                            })
                          ])
                    }),
                    0
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", { key: _vm.updatekey }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comments,
                          expression: "comments"
                        }
                      ],
                      staticStyle: { width: "100%", height: "100px" },
                      domProps: { value: _vm.comments },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.comments = $event.target.value
                          },
                          function($event) {}
                        ]
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", { key: _vm.updatekey }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.remainingitems,
                          expression: "remainingitems"
                        }
                      ],
                      staticStyle: { width: "100%", height: "100px" },
                      domProps: { value: _vm.remainingitems },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.remainingitems = $event.target.value
                          },
                          function($event) {}
                        ]
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._m(6),
                  _vm._v(" "),
                  _vm._l(_vm.materials, function(material, id) {
                    return _c("tr", { key: _vm.updatekey }, [
                      _c("td", { staticStyle: { width: "50px" } }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.clearMaterial(id)
                              }
                            }
                          },
                          [_vm._v("X")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "10%" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: material[2],
                              expression: "material[2]"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          domProps: { value: material[2] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(material, 2, $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { width: "30%" } },
                        [
                          _c("autocomplete", {
                            staticStyle: { width: "100%" },
                            attrs: { id: "'material'+id", type: 50, index: id },
                            on: { finish: _vm.setMaterialData },
                            model: {
                              value: material[1],
                              callback: function($$v) {
                                _vm.$set(material, 1, $$v)
                              },
                              expression: "material[1]"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "60%" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: material[3],
                              expression: "material[3]"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          domProps: { value: material[3] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(material, 3, $event.target.value)
                            }
                          }
                        })
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "4" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { width: "100px" },
                          on: {
                            click: function($event) {
                              return _vm.addMaterial()
                            }
                          }
                        },
                        [_vm._v("Add")]
                      )
                    ])
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(7),
              _vm._v(" "),
              _c(
                "tbody",
                { key: "updatekey" },
                [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm._l(_vm.reportTimes, function(reportTime, id) {
                    return _c("tr", { staticClass: "workTimesBox" }, [
                      _c("td", { staticStyle: { width: "50px" } }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.clearReportTime(id)
                              }
                            }
                          },
                          [_vm._v("X")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "40%" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: reportTime[1],
                              expression: "reportTime[1]"
                            }
                          ],
                          staticStyle: {
                            height: "20px",
                            top: "5px",
                            "font-size": "10px"
                          },
                          attrs: { tabindex: "-1", onClick: "this.select();" },
                          domProps: { value: reportTime[1] },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(reportTime, 1, $event.target.value)
                              },
                              function($event) {}
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: reportTime[2],
                              expression: "reportTime[2]"
                            }
                          ],
                          staticStyle: { height: "30px", bottom: "5px" },
                          attrs: { onClick: "this.select();" },
                          domProps: { value: reportTime[2] },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(reportTime, 2, $event.target.value)
                              },
                              function($event) {
                                return _vm.reportTimeChanged(id, 2)
                              }
                            ]
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "40%" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: reportTime[3],
                              expression: "reportTime[3]"
                            }
                          ],
                          staticStyle: {
                            height: "20px",
                            top: "5px",
                            "font-size": "10px"
                          },
                          attrs: { tabindex: "-1", onClick: "this.select();" },
                          domProps: { value: reportTime[3] },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(reportTime, 3, $event.target.value)
                              },
                              function($event) {}
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: reportTime[4],
                              expression: "reportTime[4]"
                            }
                          ],
                          staticStyle: { height: "30px", bottom: "5px" },
                          attrs: { onClick: "this.select();" },
                          domProps: { value: reportTime[4] },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(reportTime, 4, $event.target.value)
                              },
                              function($event) {
                                return _vm.reportTimeChanged(id, 4)
                              }
                            ]
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "20%" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: reportTime[5],
                              expression: "reportTime[5]"
                            }
                          ],
                          staticStyle: { height: "30px", bottom: "5px" },
                          domProps: { value: reportTime[5] },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(reportTime, 5, $event.target.value)
                              },
                              function($event) {}
                            ]
                          }
                        })
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "4" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: { width: "100px" },
                          on: {
                            click: function($event) {
                              return _vm.addReportTime()
                            }
                          }
                        },
                        [_vm._v("Add")]
                      )
                    ])
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.times.length > 0
              ? _c("table", { key: _vm.updatekey, staticClass: "block" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.times[8][2] != ""
                    ? _c("tbody", [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "woBlock",
                              staticStyle: { height: "80px" }
                            },
                            [
                              _c("p", { staticClass: "woTitle" }, [
                                _vm._v(_vm._s(_vm.times[8][2]))
                              ]),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "woCheckboxLabel upper",
                                  attrs: { for: "checkBoxA" }
                                },
                                [_vm._v("Yes")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.statusY,
                                    expression: "statusY"
                                  }
                                ],
                                staticClass: "woCheckbox upper",
                                attrs: {
                                  tabindex: _vm.rows * 3 + 11,
                                  type: "checkbox",
                                  name: "checkBoxA"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.statusY)
                                    ? _vm._i(_vm.statusY, null) > -1
                                    : _vm.statusY
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.statusChanged("Yes")
                                  },
                                  change: function($event) {
                                    var $$a = _vm.statusY,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.statusY = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.statusY = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.statusY = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "woCheckboxLabel lower",
                                  attrs: { for: "checkBoxB" }
                                },
                                [_vm._v("No")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.statusN,
                                    expression: "statusN"
                                  }
                                ],
                                staticClass: "woCheckbox lower",
                                attrs: {
                                  tabindex: _vm.rows * 3 + 12,
                                  type: "checkbox",
                                  name: "checkBoxB"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.statusN)
                                    ? _vm._i(_vm.statusN, null) > -1
                                    : _vm.statusN
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.statusChanged("No")
                                  },
                                  change: function($event) {
                                    var $$a = _vm.statusN,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.statusN = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.statusN = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.statusN = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("table", { staticClass: "block" }, [
              _vm._m(10),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c("autocomplete", {
                        key: _vm.updatekey,
                        staticStyle: { width: "100%" },
                        attrs: { id: "employeeSearch", type: 28 },
                        on: { finish: _vm.setData },
                        model: {
                          value: _vm.employeeSearch,
                          callback: function($$v) {
                            _vm.employeeSearch = $$v
                          },
                          expression: "employeeSearch"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "saveButton",
                attrs: {
                  tabindex: _vm.rows * 3 + 13,
                  disabled: _vm.saveDisable
                },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v("Save")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", {
          attrs: { id: "resize", draggable: "" },
          on: {
            dragend: function($event) {
              return _vm.drag($event)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scroll pageborder",
            staticStyle: {
              height: "calc(100vh - 75px)",
              float: "right",
              "margin-left": "0px",
              width: "48%"
            },
            attrs: { id: "right" }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-bottom": "0px",
                  "margin-top": "0px",
                  display: "inline-block",
                  width: "100%"
                }
              },
              [
                _c(
                  "button",
                  {
                    staticStyle: {
                      float: "left",
                      width: "30%",
                      "font-weight": "bold"
                    },
                    on: {
                      click: function($event) {
                        return _vm.changePage(-1)
                      }
                    }
                  },
                  [_vm._v("Previous")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      float: "left",
                      width: "150px",
                      "text-align": "center",
                      "margin-bottom": "0px",
                      "margin-top": "5px",
                      "font-weight": "bold"
                    }
                  },
                  [_vm._v("Doc #" + _vm._s(_vm.documents[_vm.pageNumber]))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticStyle: {
                      float: "left",
                      width: "30%",
                      "font-weight": "bold"
                    },
                    on: {
                      click: function($event) {
                        return _vm.changePage(1)
                      }
                    }
                  },
                  [_vm._v("Next")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  height: "calc(100vh - 145px)",
                  "margin-bottom": "0px",
                  "margin-top": "0px"
                }
              },
              [
                _c("document", {
                  ref: "doc",
                  attrs: {
                    dir:
                      "doc_" + parseInt(_vm.documents[_vm.pageNumber]) + ".jpg",
                    doc_id: _vm.documents[_vm.pageNumber]
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "5" } }, [
          _vm._v("WORK ORDER INFORMATION")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "10" } }, [_vm._v("ADDITIONAL VALUES")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { colspan: "3" } }, [_vm._v("TIMES")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [_c("tr", [_c("th", [_vm._v("COMMENTS/NOTES")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [_c("tr", [_c("th", [_vm._v("REMAINING ITEMS")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { colspan: "4" } }, [_vm._v("MATERIALS")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "50px" } }),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("QTY")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Material")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Notes")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { colspan: "4" } }, [_vm._v("WORK TIMES")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td"),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("From")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("To")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Workers")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { colspan: "1" } }, [_vm._v("STATUS")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { colspan: "3" } }, [_vm._v("EMPLOYEE")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64b0ab36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b0ab36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Service_Reports.vue
// module id = 705
// module chunks = 0